var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSfiheadertest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 243,
    viewBox: "0 0 430 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221 100.5L146 134L223.5 169L299 135.5L221 100.5Z",
    stroke: "#C44536",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.961 78L93 134.241L224.193 193L352 136.759L219.961 78Z",
    stroke: "#C44536",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.588 47L23 133.562L225.108 224L422 137.438L218.588 47Z",
    stroke: "#C44536",
    strokeOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.25 110.595C212.423 73.1906 212.423 73.1906 210.473 72.8781C202.301 71.5682 197.086 69.598 191.291 65.6303C183.505 60.3001 178.671 53.0271 176.727 43.7199C175.393 37.3296 175.86 31.7901 178.414 23.6932C181.033 15.3933 181.111 12.5768 178.848 7.97795L177.122 4.46978L184.053 1.95459C191.924 -0.901576 191.791 -0.928006 193.831 3.89642C195.846 8.66139 195.639 15.8252 193.264 23.4907C190.878 31.1907 190.37 34.8246 191.008 39.6245C192.245 48.9291 197.974 54.9398 208.1 57.5572C213.571 58.9712 227.342 58.9562 232.204 57.5309C237.106 56.0938 241.837 53.3211 244.258 50.4664C249.663 44.0914 250.638 35.8765 247.304 24.8059C244.276 14.7509 244.439 6.11021 247.744 1.44046C248.732 0.0452193 248.732 0.0452169 254.258 1.62185C264.31 4.48956 263.595 3.92087 261.554 7.42139C259.182 11.4916 259.254 14.7997 261.927 24.4148C264.978 35.3909 264.701 42.1772 260.833 51.1698C258.136 57.4391 251.751 64.1008 245.398 67.2729C240.423 69.7573 231.887 72.5993 229.401 72.5993C226.511 72.5993 226.217 72.9723 226.691 76.039C226.928 77.5758 227.138 94.3957 227.156 113.417L227.189 148H219.633H212.077L212.25 110.595ZM177.042 129.001V121.877H190.693H204.344V129.001V136.126H190.693H177.042V129.001ZM234.99 129.001V121.877H248.641H262.292V129.001V136.126H248.641H234.99V129.001ZM177.042 105.847V98.7224H190.693H204.344V105.847V112.971H190.693H177.042V105.847ZM234.99 105.847V98.7224H248.641H262.292V105.847V112.971H248.641H234.99V105.847ZM177.042 82.6923V75.5678H190.693H204.344V82.6923V89.8168H190.693H177.042V82.6923ZM234.99 82.6923V75.5678H248.641H262.292V82.6923V89.8168H248.641H234.99V82.6923ZM225.592 49.89C224.013 46.543 221.891 41.3199 220.876 38.2832L219.029 32.762L218.08 36.5021C216.943 40.9811 210.511 55.3962 209.672 55.3472C209.346 55.3282 206.392 53.9256 203.107 52.2303L197.134 49.1479L205.057 33.2806L212.981 17.4134L219.134 17.3989L225.287 17.3845L233.242 33.1747C237.618 41.8593 241.117 49.0394 241.019 49.1304C240.612 49.5071 229.021 55.9754 228.753 55.9754C228.593 55.9754 227.17 53.237 225.592 49.89Z",
    fill: "#C44536"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.25 110.595C216.423 73.1906 216.423 73.1906 214.473 72.8781C206.301 71.5682 201.086 69.598 195.291 65.6303C187.505 60.3001 182.671 53.0271 180.727 43.7199C179.393 37.3296 179.86 31.7901 182.414 23.6932C185.033 15.3933 185.111 12.5768 182.848 7.97795L181.122 4.46978L188.053 1.95459C195.924 -0.901576 195.791 -0.928006 197.831 3.89642C199.846 8.66139 199.639 15.8252 197.264 23.4907C194.878 31.1907 194.37 34.8246 195.008 39.6245C196.245 48.9291 201.974 54.9398 212.1 57.5572C217.571 58.9712 231.342 58.9562 236.204 57.5309C241.106 56.0938 245.837 53.3211 248.258 50.4664C253.663 44.0914 254.638 35.8765 251.304 24.8059C248.276 14.7509 248.439 6.11021 251.744 1.44046C252.732 0.0452193 252.732 0.0452169 258.258 1.62185C268.31 4.48956 267.595 3.92087 265.554 7.42139C263.182 11.4916 263.254 14.7997 265.927 24.4148C268.978 35.3909 268.701 42.1772 264.833 51.1698C262.136 57.4391 255.751 64.1008 249.398 67.2729C244.423 69.7573 235.887 72.5993 233.401 72.5993C230.511 72.5993 230.217 72.9723 230.691 76.039C230.928 77.5758 231.138 94.3957 231.156 113.417L231.189 148H223.633H216.077L216.25 110.595ZM181.042 129.001V121.877H194.693H208.344V129.001V136.126H194.693H181.042V129.001ZM238.99 129.001V121.877H252.641H266.292V129.001V136.126H252.641H238.99V129.001ZM181.042 105.847V98.7224H194.693H208.344V105.847V112.971H194.693H181.042V105.847ZM238.99 105.847V98.7224H252.641H266.292V105.847V112.971H252.641H238.99V105.847ZM181.042 82.6923V75.5678H194.693H208.344V82.6923V89.8168H194.693H181.042V82.6923ZM238.99 82.6923V75.5678H252.641H266.292V82.6923V89.8168H252.641H238.99V82.6923ZM229.592 49.89C228.013 46.543 225.891 41.3199 224.876 38.2832L223.029 32.762L222.08 36.5021C220.943 40.9811 214.511 55.3962 213.672 55.3472C213.346 55.3282 210.392 53.9256 207.107 52.2303L201.134 49.1479L209.057 33.2806L216.981 17.4134L223.134 17.3989L229.287 17.3845L237.242 33.1747C241.618 41.8593 245.117 49.0394 245.019 49.1304C244.612 49.5071 233.021 55.9754 232.753 55.9754C232.593 55.9754 231.17 53.237 229.592 49.89Z",
    fill: "#C44536",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 12,
    width: 15,
    height: 15,
    fill: "#C44536"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 179,
    width: 15,
    height: 15,
    fill: "#733530"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 52,
    width: 15,
    height: 15,
    fill: "#C44536"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    width: 11,
    height: 11,
    fill: "#70322D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 232,
    width: 11,
    height: 11,
    fill: "#70322D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 14,
    width: 11,
    height: 11,
    fill: "#70322D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 54,
    width: 8,
    height: 8,
    fill: "#70322D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 192,
    width: 8,
    height: 8,
    fill: "#70322D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 36,
    width: 8,
    height: 8,
    fill: "#70322D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 209,
    width: 8,
    height: 8,
    fill: "#C44536"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 193,
    width: 8,
    height: 8,
    fill: "#C44536"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 214,
    width: 8,
    height: 8,
    fill: "#733530"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 91,
    width: 8,
    height: 8,
    fill: "#C44536"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfiheadertest);
export default __webpack_public_path__ + "static/media/sfiheadertest.668eafb63cf9435ea0bcfaa5ca79adcb.svg";
export { ForwardRef as ReactComponent };